import { useState } from 'react';
import { Check, ChevronRight } from 'lucide-react';
import { CATALOGO } from '@/constants/catalogo';
import { fmt } from '@/lib/utils';
import CfgCX from './CfgCX';
import CfgShowroom from './CfgShowroom';
import CfgVariantes from './CfgVariantes';
import CfgFijo from './CfgFijo';
import CfgLanding from './CfgLanding';
import CfgIdentidad from './CfgIdentidad';
import CfgRenders from './CfgRenders';
import CfgContenido from './CfgContenido';

export default function ProductoConfig({ producto, onUpdate }) {
  const catalogo = CATALOGO[producto.id];
  const Icon = catalogo.icon;
  const [expanded, setExpanded] = useState(!producto.configurado);

  const renderConfig = () => {
    switch (producto.id) {
      case 'clickXperience':
        return <CfgCX producto={producto} onUpdate={onUpdate} />;
      case 'showroomSoftware':
        return <CfgShowroom producto={producto} onUpdate={onUpdate} />;
      case 'plataformaMadre':
      case 'produccionAV':
      case 'produccionXRE':
        return <CfgVariantes producto={producto} onUpdate={onUpdate} catalogo={catalogo} />;
      case 'landingXperience':
        return (
          <CfgFijo
            producto={producto}
            onUpdate={onUpdate}
            precio={96500}
            desc="Landing con portafolio dinámico, mapa, contacto, direccionamiento a C&X, hosting 1 año, SEO básico"
          />
        );
      case 'landing':
        return <CfgLanding producto={producto} onUpdate={onUpdate} />;
      case 'identidad':
        return <CfgIdentidad producto={producto} onUpdate={onUpdate} />;
      case 'rendersHyper':
        return <CfgRenders producto={producto} onUpdate={onUpdate} />;
      case 'contenido':
        return <CfgContenido producto={producto} onUpdate={onUpdate} />;
      default:
        return null;
    }
  };

  return (
    <div className="bg-neutral-900/50 border border-neutral-800 rounded-xl overflow-hidden">
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between p-4 hover:bg-neutral-900/80"
      >
        <div className="flex items-center gap-3">
          <div className="w-9 h-9 rounded-lg bg-neutral-800 flex items-center justify-center">
            <Icon className="w-4 h-4 text-brand-gold" />
          </div>
          <div className="text-left">
            <div className="text-white font-semibold text-sm">{catalogo.nombre}</div>
            <div className="text-xs text-neutral-500">
              {producto.configurado
                ? `${fmt(producto.precioFinal || 0)}`
                : 'Sin configurar'}
            </div>
          </div>
        </div>
        <div className="flex items-center gap-2">
          {producto.configurado && <Check className="w-4 h-4 text-green-500" />}
          <ChevronRight
            className={`w-4 h-4 text-neutral-500 transition-transform ${
              expanded ? 'rotate-90' : ''
            }`}
          />
        </div>
      </button>
      {expanded && (
        <div className="px-4 pb-4 pt-2 border-t border-neutral-800">{renderConfig()}</div>
      )}
    </div>
  );
}
